module.exports = __webpack_public_path__ + "static/img/ic_zhifubao_white.7c8db459.png";